import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { applyStyleModifiers } from 'styled-components-modifiers';

import { flex, rem } from '../../core';

const modifiers = {
  primary: ({ theme }) => ({
    styles: `
      background-color: ${theme.primary.main};
      color: ${theme.primary.main};
      span {
        color: ${theme.primary.contrastText};
      }

      svg {
        path {
          stroke: white;
        }
      }

      &:hover {
        background-color: ${theme.primary.dark};
      }
    `,
  }),
  dark: ({ theme }) => ({
    styles: `
      background-color: ${theme.primary.dark};
      color: ${theme.primary.dark};
      span {
        color: ${theme.primary.contrastText};
      }
      svg {
        path {
          stroke: white;
        }
      }
    `,
  }),
  darkest: () => ({
    styles: `
      background-color: #0A598F;
      color: white;
    `,
  }),
  secondary: ({ theme }) => ({
    styles: `
      background-color: ${theme.primary.contrastText};
      color: ${theme.primary.main};
      border: 1px solid ${theme.primary.main};
      span {
        color: ${theme.primary.main};
      }
      svg {
        path {
          stroke: #0A598F;
        }
      }

      &:hover {
        background-color: ${theme.greyLighter1};
      }
    `,
  }),
  wShadow: () => ({
    styles: `
      background-color: white;
      box-shadow: 0 ${rem(2)} ${rem(20)} rgba(216, 216, 216, .67);
    `,
  }),
  disabled: ({ theme }) => ({
    styles: `
      background-color: ${theme.disabled.main};
      color: ${theme.disabled.contrastText};
      border: solid 1px ${theme.disabled.dark};
      pointer-events: none;
      span {
        color: ${theme.disabled.contrastText};
      }
      svg {
        path {
          stroke: ${theme.disabled.contrastText};
        }
      }
    `,
  }),
  outline: ({ theme }) => ({
    styles: `
      background-color: ${theme.primary.contrastText} !important;
      border: solid 1px;
      span {
        color: inherit;
      }
      svg {
        path {
          stroke: ${theme.primary.main};
        }
      }
    `,
  }),
  woBorder: () => ({
    styles: `
      border: none;
    `,
  }),
  textButton: ({ theme }) => ({
    styles: `
      background-color: transparent;
      height: auto;
      padding: 0;
      justify-content: flex-start;

      span {
        font-weight: 500;
        text-decoration: underline;
        color: ${theme.primary.main};
        cursor: pointer;
      }
      svg {
        path {
          stroke: ${theme.primary.main};
        }
      }
    `,
  }),
  loading: () => ({
    styles: `
      svg {
        width: 0.9rem;
        transition-property: transform;
        animation-name: rotate; 
        animation-duration: 0.4s; 
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    
        @keyframes rotate {
          0% {
            transform: rotate(0deg);
          }
          75% {
            transform: rotate(300deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      }
    `,
  }),
};

const commonStyle = `
  text-decoration: none;
  width: 100%;
  min-width: ${rem(92)};
  height: ${rem(44)};
  background-color: ${(props) => props.theme.primary.main};
  outline: none;
  padding: 0.9rem;
  border: none;
  border-radius: 0.313rem;
  margin: 0;
  ${flex('row', 'center', 'center')};
  cursor: pointer;
  transition: all 0.25s ease;

  span {
    font-size: ${rem(14)};
    font-weight: 600;
    text-align: center;
    pointer-events: none;
  }

  svg {
    margin-right: 0.5rem;
  }
  &:disabled {
    background-color: ${(props) => props.theme.disabled.main};
    color: ${(props) => props.theme.disabled.contrastText};
    border: solid 1px ${(props) => props.theme.disabled.dark};
    pointer-events: none;
    span {
      color: ${(props) => props.theme.disabled.contrastText};
    }
  }
`;

export const ButtonStyled = styled.button.attrs({
  className: 'component__button',
})`
  ${commonStyle}
  ${applyStyleModifiers(modifiers)};
`;
export const LinkStyled = styled(Link).attrs({
  className: 'component__button',
})`
  ${commonStyle}
  ${applyStyleModifiers(modifiers)};
`;

export const AnchorStyled = styled.a.attrs({
  className: 'component__button',
})`
  ${commonStyle}
  ${applyStyleModifiers(modifiers)};
`;
